import { render } from "./CreateGoalModal.vue?vue&type=template&id=14fcc012&scoped=true"
import script from "./CreateGoalModal.vue?vue&type=script&lang=js"
export * from "./CreateGoalModal.vue?vue&type=script&lang=js"

import "./CreateGoalModal.vue?vue&type=style&index=0&id=14fcc012&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fcc012"]])

export default __exports__